import { supabase } from './supabase';

export async function generateOrderNumber(): Promise<string> {
  try {
    const { data, error } = await supabase.rpc('generate_order_number');

    if (error) {
      console.error('Error generating order number:', error);
      throw error;
    }

    return data as string;
  } catch (error) {
    console.error('Failed to generate order number:', error);
    const currentYear = new Date().getFullYear();
    const randomNum = Math.floor(Math.random() * 10000);
    return `${currentYear}${randomNum}`;
  }
}

export function formatOrderDate(): string {
  const now = new Date();
  const day = now.getDate().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const year = now.getFullYear();
  return `${day}.${month}.${year}`;
}

export function formatOrderTime(): string {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}
